import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardCuentaBancaria extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    download = (e) => {
        e.preventDefault();
        let name = e.target.parentNode.dataset.name;
        let url = e.target.parentNode.dataset.url;
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                });
            });
    };

    render() {
        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardHeader className="text-center">
                        <b>Cuenta Registrada</b>
                    </CardHeader>
                    <CardBody>
                        <CardText>
                            <span className="spanCard">Entidad Financiera: </span> {this.props.objeto.strBanco}
                            <br />
                            <span className="spanCard">Tipo de cuenta: </span> {this.props.objeto.strTipoCuenta}
                            <br />
                            <span className="spanCard">Número de cuenta: </span> {this.props.objeto.nrocuenta}
                            <br />
                            <span className="spanCard">Estado: </span> {this.props.objeto.estado == "A" ? (this.props.objeto.strEstado) : ('Inactivo')}
                            <br />
                            <span className="spanCard">Fecha de registro: </span> {this.parseDate(this.props.objeto.fecharegistro)}
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            {this.props.evidenciaSolicitud.map((evidencia, idx) =>
                                <CardLink onClick={this.download} data-name={evidencia.name} data-url={evidencia.url} key={idx} href="#" title="Solicitud"><i className="fas fa-downloadx" aria-hidden="true"></i></CardLink>
                            )}
                            {this.props.evidencias.map((evidencia, idx) =>
                                <CardLink onClick={this.download} data-name={evidencia.name} data-url={evidencia.url} key={idx} href="#" title="Documento"><i className="fas fa-downloadx" aria-hidden="true"></i></CardLink>
                            )}
                            {/*{this.props.objeto.estado == "A" ?*/}
                            {/*    (<CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>)*/}
                            {/*    : ('')}*/}
                            {this.props.objeto.estado == "A" && this.props.objeto.estadorevisionth == 1 ?
                                (<CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-altx" aria-hidden="true"></i></CardLink>)
                                : ('')
                                }
                        </div>
                    </CardFooter>
                </Card>
                <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                    <ModalBody>
                        ¿Está seguro que desea anular el registro?
                        </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div>
        )

    }
}